import {FC} from "react";
import {BaseIcon, IPropsIcon} from "./BaseIcon";

interface IProps extends IPropsIcon {

}

export const PlusIcon:FC<IProps> = ({size= 15,fill='none'})=>{
    return (
        <BaseIcon size={size} viewBox="0 0 13 13" fill={fill}>
            <path d="M11.375 5.52795L7.4375 5.52795L7.4375 1.59045C7.4375 1.12561 7.02734 0.715454 6.5625 0.715454L5.6875 0.715454C5.19531 0.715454 4.8125 1.12561 4.8125 1.59045L4.8125 5.52795L0.875 5.52795C0.382813 5.52795 0 5.93811 0 6.40295L0 7.27795C0 7.77014 0.382813 8.15295 0.875 8.15295H4.8125L4.8125 12.0905C4.8125 12.5826 5.19531 12.9655 5.6875 12.9655H6.5625C7.02734 12.9655 7.4375 12.5826 7.4375 12.0905L7.4375 8.15295H11.375C11.8398 8.15295 12.25 7.77014 12.25 7.27795V6.40295C12.25 5.93811 11.8398 5.52795 11.375 5.52795Z" fill="#0D0D0E"/>
        </BaseIcon>
    )
}